// src/pages/user/components/executorClusters/ExecutorClusters.tsx
import React from 'react'
import { ExecutorClusterResponse } from '../../../../common/types/interfaces'
import { ExecutorClusterItem } from './components/executorClusterItem/ExecutorClusterItem'
import classes from './ExecutorClusters.module.sass'

type Props = {
  clusters: ExecutorClusterResponse[]
  onStatsClick: (cluster: ExecutorClusterResponse) => void
  onDetailsClick: (cluster: ExecutorClusterResponse) => void
  onGoTo: (cluster: ExecutorClusterResponse) => void
  onSettingsClick: (cluster: ExecutorClusterResponse) => void
}

export const ExecutorClusters: React.FC<Props> = ({
  clusters,
  onStatsClick,
  onDetailsClick,
  onGoTo,
  onSettingsClick,
}) => {
  if (!clusters || clusters.length === 0) {
    return null
  }

  return (
    <div className={classes.container}>
      <div className={classes.header}>Кластеры</div>
      <div className={classes.list}>
        {clusters.map((cluster) => {
          if (!cluster?.cluster?.id) return null
          return (
            <ExecutorClusterItem
              key={cluster.cluster.id}
              cluster={cluster}
              onStatsClick={onStatsClick}
              onDetailsClick={onDetailsClick}
              onGoTo={onGoTo}
              onSettingsClick={onSettingsClick}
            />
          )
        })}
      </div>
    </div>
  )
}
